Core.UsersRouter = Core.SubRouter.extend({
    routes: {
        '': 'users',
        'groupmatrix': 'groupMatrix',
        'group/:id': 'viewGroup',
        'me': 'viewUserMe',
        'me/edit': 'editUserMe',
        ':id': 'viewUser',
        ':id/edit': 'editUser',
        ':id/avatar': 'avatar',
    },

    users: function () {
      debug.log('users');
      var view = new UserListView({scrolling: true});
      view.fetch();
      app.setMainView(view, 'directory');
    },

    groupMatrix: function () {
        debug.log('user group matrix');
        var view = new UserGroupMatrixView();
        app.setMainView(view, 'directory');
    },

    viewGroup: function(id) {
        debug.log('view group ' + id);
        var view = new UserListView({scrolling: true});
        view.fetchGroup(parseInt(id));
        app.setMainView(view, 'directory');
    },

    viewUserMe: function () {
        debug.log('user me');
        var view = app.setMainView(new UserDetailsView({myAccount: true}), 'settings');
        view.editing = false;
        view.setModel(new User(Core.client.me.toJSON()));
        view.model.fetch();
        view.render();
    },

    editUserMe: function () {
        debug.log('edit user me');
        var view = app.setMainView(new UserDetailsView({myAccount: true}), 'directory');
        view.editing = true;
        view.setModel(new User(Core.client.me.toJSON()));
        view.model.fetch();
        view.render();
    },

    viewUser: function(id) {
        debug.log('view user ' + id);
        var view = app.setMainView(new UserDetailsView(), 'directory');
        view.editing = false;
        if (!view.model || view.model.id != id)
            view.setModel(new User({id: id}));
        view.model.fetch().error(function (response) { errorResponse(response.responseText); });
        view.render();
    },

    editUser: function(id) {
        debug.log('edit user ' + id);
        var view = app.setMainView(new UserDetailsView(), 'directory');
        view.editing = true;
        if (!view.model || view.model.id != id)
            view.setModel(new User({id: id}));
        view.model.fetch().error(function (response) { errorResponse(response.responseText); });
        view.render();
    },

    avatar: function(id) {
        debug.log('avatar ' + id);
        var view = app.setMainView(new AvatarView({id: id}), 'directory');
        // TODO view.federatedIdentityProvider = '#{sessionScope.federatedIdentityProvider}';
    },

});
